/* eslint-disable camelcase */

export function GET_ENTRY_URL_INFO () {
  try {
    const referrer = document.referrer || ''
    const current_host = window.location.host
    const current_pathname = window.location.pathname
    const current_url = current_host + current_pathname
    let referrer_host = ''

    if (referrer) {
      const referrer_url = new URL(referrer)
      referrer_host = referrer_url.host
    }

    return {
      referrer,
      referrer_host,
      current_host,
      current_pathname,
      current_url
    }
  } catch (error) {
    return {}
  }
}
